import React, { useEffect, useState } from 'react';
import './OrderDetailPage.css';
import SidebarComponent from '../components/SidebarComponent';
import TitleComponent from "../components/TitleComponent";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { FullOrder, OrderEvents, OrderSources, ShopeeTrackingInfo } from '../interfaces/OrderInterfaces';
import { Drivers } from '../interfaces/AccessInterfaces';
import OrderComponent from '../components/OrderComponent';
import {
    Card,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TableHeaderCell,
    Metric,
    Button,
    Flex,
    Grid,
    Col,
    Divider,
    Title,
    Text,
} from '@tremor/react';
import PDFStickerComponent from '../components/stickerComponents/MazelogStickerComponent';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { Link } from "react-router-dom";
import { convertDateTime, convertDateTimeBr, convertDateTimeTimestamp } from '../utils/convertDate';
import { meliSubStatusTranslate, shopeeLogisticStatusTranslate, statusChannelTranslate } from '../utils/translates';

export default function OrderDetailPage(
        {
            drivers,
            setShowCard,
            setManualBaseOrder,
            setReverseLogistic
        }:
        {
            drivers:Drivers,
            setShowCard:Function,
            setManualBaseOrder:Function,
            setReverseLogistic:Function
        }
    ) {
    const [cookies] = useCookies(['mazelog-user']);
    const productFlag = cookies['mazelog-user']?.organization_data?.product_flag
    const token = cookies['mazelog-user']?.token_data?.access_token
    const oauth = "Bearer " + token

    const userProfile = cookies['mazelog-user']?.user_data?.user_profile;
    const isTransporter = userProfile === "TRANSPORTER" || userProfile === "TRANSPORTER_COLLECTER"
    const isClient = userProfile === "CLIENT"

    const statusTranslate: { [key: string]: string } = {
        "created": "Criado",
        "transporter_allocated": "Transportador alocado",
        "collected": "Coletado",
        "received": "Recebido",
        "en_route": "Em rota",
        "delivered": "Entregue",
        "cancelled": "Cancelado",
        "handling": "Em tratativa",
        "awaiting_return": "Aguard. devolução",
        "awaiting_transfer": "Aguard. transferência",
        "return_route": "Rota devolução",
        "returned": "Devolvido",
        "collected_not_received": "Coletados Não Receb.",
        "cancelled_after_received": "Canc. após Receb.",
        "returned_area_not_serviced": "Devolvido - Área não atendida",
        "new_driver_allocated": "Novo entregador alocado"
    }

    const meliStatusTranslate: { [key: string]: string } = {
        "handling": "Em manejo",
        "ready_to_ship": "Pronto para envio",
        "shipped": "A caminho",
        "first_visit": "Primeira visita",
        "delivered": "Entregue"
    }




    let { id } = useParams();
    const [order, setOrder] = useState<FullOrder>();
    const [orderUpdated, setOrderUpdated] = useState<boolean>(false);
    const [meliTagDownloading, setMeliTagDownloading] = useState<boolean>(false);
    const [meliOrderDelivered, setMeliOrderDelivered] = useState<boolean>(false);
    const [isShopeeOrder, setIsShopeeOrder] = useState<boolean>(false);

    const [correiosOrders, setCorreiosOrders] = useState<boolean>(false);
    const [reverseLogisticOrder, setReverseLogisticOrder] = useState<boolean>(false);
    const [stickerButtonDisabled, setStickerButtonDisabled] = useState<boolean>(true);
    const [declarationButtonDisabled, setDeclaraionButtonDisabled] = useState<boolean>(false);
    const [correiosTagDownloading, setCorreiosTagDownloading] = useState<boolean>(false);
    const [cancelButtonDisabled, setCancelButtonDisabled] = useState<boolean>(false);

    const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;

    const navigate = useNavigate();
    useEffect(()=>{
        axios.get(`${baseURL}/order/${id}`,{headers: {"Authorization": oauth}})
            .then((res) => {
                console.log(res);
                setOrder(res.data);
            })
            .catch((err) => {
                console.log(err);
                navigate(`/`);
            })
    },[id,orderUpdated])

    useEffect(() => {
        if (order?.source == "shopee") {
            setIsShopeeOrder(true)
        }
        else if (!!order?.mercado_livre) {
            setMeliOrderDelivered(true)
        }
        if (order?.transporter === "correios") {
            setCorreiosOrders(true);
        }
        setReverseLogisticOrder(!!order?.reverseLogistic);

        //download sticker
        setStickerButtonDisabled(!(
            order?.correios &&
            order?.correios?.statusPostagem[order?.correios?.statusPostagem.length - 1].description === "Pré-postado" &&
            (new Date(order?.correios?.prazoPostagem) > new Date())
        ));

        //declaration
        setDeclaraionButtonDisabled(false);

        setCancelButtonDisabled(Boolean(order) &&
            Boolean(['delivered', 'cancelled'].includes(order!.events[order!.events.length - 1].type))
        );

    }, [order])

    const downloadMercadoLivreStickerTag = () => {
        setMeliTagDownloading(true);
        axios.post(`${baseURL}/mercado_livre/tag`,
            {order_id: id},
            {
                headers: {
                    "Authorization": oauth,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            })
            .then((res:any) => {
                var urlCreator = window.URL || window.webkitURL;
                let imageUrl = urlCreator.createObjectURL(res.data);
                window.open(imageUrl, '_blank', 'noopener,noreferrer');
            })
            .catch(async (err) => {
                const response = await err.response.data.text();
                const errorData = JSON.parse(response);
                alert(`Erro na geração da etiqueta! ${errorData.detail}`)
                }
            )
            .finally(() => setMeliTagDownloading(false))
    }

    const downloadShopifyStickerTag = () => {
        setMeliTagDownloading(true);
        axios.get(`${baseURL}/shopee/tag/${id}`,
            {
                headers: {
                    "Authorization": oauth,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            })
            .then((res:any) => {
                var urlCreator = window.URL || window.webkitURL;
                let imageUrl = urlCreator.createObjectURL(res.data);
                window.open(imageUrl, '_blank', 'noopener,noreferrer');
            })
            .catch(async (err) => {
                const response = await err.response.data.text();
                const errorData = JSON.parse(response);
                alert(`Erro na geração da etiqueta! ${errorData.detail}`)
                }
            )
            .finally(() => setMeliTagDownloading(false))
    }

     const downloadCorreiosStickerTag = () => {
        setCorreiosTagDownloading(true);
        axios.post(`${baseURL}/correios/tag`,
                    {
                    data: [id],
                    "product_flag": productFlag,
                    },
                    {
                        headers: {
                            "Authorization": oauth,
                        },
                        responseType: 'blob'
                    })
            .then((response) => new Blob([response.data]))
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `etiqueta_correios_${id}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                })
            .catch((err) =>
                alert("Etiqueta dos correios ainda está sendo gerada, tente mais tarde.")
            )
            .finally(() => setCorreiosTagDownloading(false))
    }

    const deleteOrder = async () => {
        if (window.confirm("Deseja mesmo apagar esse pedido?")){
            axios.delete(`${baseURL}/order/${id}/delete`,{headers: {"Authorization": oauth}})
            .then((res) => {
                console.log(res);
                navigate(`/`);
            })
            .catch((err) => {
                console.log(err);
            })
        }
    }

    const cancelOrder = async () => {
        if (window.confirm("Deseja mesmo cancelar este pedido?")){
            axios.delete(`${baseURL}/order/${id}`,{headers: {"Authorization": oauth}})
            .then((res) => {
                console.log(res);
                setOrderUpdated(true);
            })
            .catch((err) => {
                console.log(err);
                if (axios.isAxiosError(err) && err.response) {
                    alert(err.response?.data?.detail);
                }
            })
        }
    }

    const deleteOrderStatus = async (event:OrderEvents) => {
        if (window.confirm("Deseja mesmo remover esse status?")){
            axios.put(`${baseURL}/order/${id}/status/mistake`,
            {mistake: event},
            {headers: {"Authorization": oauth}})
            .then((res) => {
                console.log(res);
                setOrderUpdated(true);
            })
            .catch((err) => {
                console.log(err);
            })
        }
    }
    
    const convertDate = (date:string) => {
        const pos = date.indexOf("+");
        if (pos !== -1) {
            date = date.substring(0, pos);
        }
        let newDate = new Date(date);
        newDate.setHours(newDate.getHours() - 3);
        return newDate.toLocaleString('pt-BR');
    }

    const reverseLogisticHandler = () => {
        setShowCard("1");
        setManualBaseOrder(order);
        setReverseLogistic(true);
        navigate(`/create`);
    }

const hasPrintedStatus = order && Array.isArray(order.meli_status_history) && 
    order.meli_status_history.some(event => event.substatus === "printed");

  return (
    <main>
        <SidebarComponent />
        <div className='OrderContent'>
            <TitleComponent />
            <div className='flex pl-10'>
                { !order?.reverseLogistic ?
                    <div>
                        <Button
                            className='DownloadBtn'
                            onClick={reverseLogisticHandler}
                        >
                        Criar etiqueta logística reversa
                        </Button>
                    </div> 
                    : ""
                }
                {order ? 
                (<div  className='flex'>
                    {
                        order?.transporter === "correios" || order.source === OrderSources.UNKNOWN ? (
                            <></>
                        ) :
                        order.source === OrderSources.MAZELOG ?
                        (
                            <Button className='DownloadBtn'>
                                <PDFDownloadLink
                                    document={<PDFStickerComponent orderList={[order]} productFlag={productFlag} />}
                                    fileName={`${order?.orderNumber}.pdf`}
                                >
                                Baixar etiqueta
                                </PDFDownloadLink>
                            </Button>
                        ) :
                        isShopeeOrder ? (
                            <Button
                                className='DownloadBtn'
                                onClick={downloadShopifyStickerTag}
                                loading={meliTagDownloading}
                            >Baixar etiqueta Shopee</Button>
                        ) :
                        (
                            <Button
                                className='DownloadBtn'
                                onClick={downloadMercadoLivreStickerTag}
                                loading={meliTagDownloading}
                                disabled={!hasPrintedStatus}
                            >Baixar etiqueta Mercado Livre</Button>
                        )
                    }
                    {(correiosOrders && !reverseLogisticOrder) ?
                        <div>
                            <Button
                                className='DownloadBtn'
                                disabled={stickerButtonDisabled}
                                onClick={downloadCorreiosStickerTag}
                                loading={correiosTagDownloading}
                            >Baixar etiqueta Correios</Button>
                            <Link to={`/orders/declaration/${order?.orderNumber}`} target="_blank" rel="noopener noreferrer">
                                <Button
                                    className='DownloadBtn'
                                    disabled={declarationButtonDisabled}
                                >Baixar declaração de conteúdo</Button>
                            </Link>
                        </div> : ""
                    }
                    <Link to={`/occurrence/${order.orderNumber}`}>
                        <Button className='DownloadBtn'>Abrir ocorrência</Button>
                    </Link>
                </div>
                ) :
                (<div>
                    <Button className='DownloadBtn' disabled={true}>Baixar etiqueta</Button>
                    <Button className='DownloadBtn' disabled={true}>Abrir ocorrência</Button>
                </div>
                )}
                {!isTransporter && !isClient && order?.transporter !== "correios" && (
                    <Button className='DownloadBtn' onClick={deleteOrder}>Apagar</Button>
                )}
                {
                    order?.transporter === "correios" && (
                        <Button
                            className='DownloadBtn'
                            onClick={cancelOrder}
                            disabled={cancelButtonDisabled}
                        >Cancelar pedido</Button>
                    )
                }
            </div>
            <div className="DashboardViews">
                <OrderComponent order={order} />
            </div>
            <div className='px-8'>
                <Card>
                    <Metric>Histórico do pedido</Metric>
                    {
                    (order?.transporter === "correios")&&(order.correios?.statusPostagem.length) ?
                        (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableHeaderCell>Código Correios</TableHeaderCell>
                                        <TableHeaderCell>Status</TableHeaderCell>
                                        <TableHeaderCell>Data</TableHeaderCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {order.correios.statusPostagem
                                        .map((event) => (
                                        <TableRow key={ event?.code }>
                                            <TableCell className="TableField">{ event?.code }</TableCell>
                                            <TableCell className="TableField">{ event?.description }</TableCell>
                                            <TableCell className="TableField">{ convertDate(event?.date) }</TableCell>
                                        </TableRow>
                                        ))}
                                </TableBody>
                            </Table> 
                        ) :
                    isShopeeOrder ?
                        (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableHeaderCell>Status</TableHeaderCell>
                                        <TableHeaderCell>Data</TableHeaderCell>
                                        {(!isClient) && (
                                            <TableHeaderCell>Entregador</TableHeaderCell>
                                        )}
                                        {(!isClient && !isTransporter) && (
                                            <TableHeaderCell>Remover</TableHeaderCell>
                                        )}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    { order?.events
                                        .filter((e) => e?.hidden_event !== true)
                                        .map((event) => (
                                            <TableRow key={ event?.type + event?.date }>
                                                <TableCell className="TableField">{ statusTranslate[event?.type] }</TableCell>
                                                <TableCell className="TableField">
                                                    { event?.date.endsWith("+00:00")
                                                        ? convertDateTime(event?.date)
                                                        : convertDateTimeBr(event?.date)
                                                    }
                                                </TableCell>
                                                {(!isClient) && (
                                                    <TableCell className="TableField">{ (event?.id_user) && (event?.id_user in drivers) ? drivers[event?.id_user].email : "" }</TableCell>
                                                )}
                                                {(['created','transporter_allocated'].includes(event?.type) || isClient || !isTransporter) ? "" :
                                                    <Button onClick={() => {deleteOrderStatus(event)}} className='DeleteStatusBtn'/>
                                                }
                                            </TableRow>
                                        )) }
                                </TableBody>
                            </Table>
                        ) :                     
                        (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableHeaderCell>Status</TableHeaderCell>
                                        <TableHeaderCell>Data</TableHeaderCell>
                                        {(!isClient) && (
                                            <TableHeaderCell>Entregador</TableHeaderCell>
                                        )}
                                        {(!isClient && !isTransporter) && (
                                            <TableHeaderCell>Remover</TableHeaderCell>
                                        )}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    { order?.events
                                        .filter((e) => e?.hidden_event !== true)
                                        .map((event) => (
                                            <TableRow key={ event?.type + event?.date }>
                                                <TableCell className="TableField">{ statusTranslate[event?.type] }</TableCell>
                                                <TableCell className="TableField">{ convertDateTimeBr(event?.date) }</TableCell>
                                                {(!isClient) && (
                                                    <TableCell className="TableField">{ (event?.id_user) && (event?.id_user in drivers) ? drivers[event?.id_user].email : "" }</TableCell>
                                                )}
                                                {(['created','transporter_allocated'].includes(event?.type) || isClient || !isTransporter) ? "" :
                                                    <Button onClick={() => {deleteOrderStatus(event)}} className='DeleteStatusBtn'/>
                                                }
                                            </TableRow>
                                        )) }
                                </TableBody>
                            </Table>
                        )
                    }
                </Card>
            </div>
            <br/>
            <div>
                <div className='px-8' >
                    {(order)&&(order.source === OrderSources.MAZELOG) && order?.transporter !== "correios" ? 
                    (<div>
                        <Card>
                            <Metric className='mb-4'>Etiqueta</Metric>
                            <PDFViewer className='PDFCard' showToolbar={false}>
                                <PDFStickerComponent orderList={[order]} productFlag={productFlag} />
                            </PDFViewer>
                        </Card>
                    </div>) :
                    ('')}
                </div>

                {/* Mercado Livre */}
                <div className='px-8'> 
                    {(order?.source === OrderSources.MERCADO_LIVRE && !!order.mercado_livre) ?
                    (<div>
                        <Card>
                            <Metric>Informações do pedido do Canal</Metric>
                            <Grid numCols={2} className="gap-2">
                                <Col numColSpan={1}>
                                    <Title>Canal</Title>
                                    <Text className='max-w-md'>Mercado Livre</Text>
                                </Col>
                                <Col numColSpan={1}>
                                    <Title>ID do pedido</Title>
                                    <Text className='max-w-md'>{order?.mercado_livre?.order_id}</Text>
                                </Col>
                                <Col numColSpan={1}>
                                    <Title>ID da entrega</Title>
                                    <Text className='max-w-md'>{order?.mercado_livre?.shipping_id}</Text>
                                </Col>
                                <Col numColSpan={1}>
                                    <Title>Seller ID</Title>
                                    <Text className='max-w-md'>{order?.mercado_livre?.seller_id}</Text>                  
                                </Col>
                                <Col numColSpan={1}>
                                    <Title>Substatus do pedido</Title>
                                    <Text>{order?.mercado_livre?.order_status}</Text>
                                </Col>
                                <Col numColSpan={1}>
                                    <Title>Descrição do serviço</Title>
                                    <Text>{order?.mercado_livre?.serviceDescription}</Text>
                                </Col>
                                <Col numColSpan={1}>
                                    <Title>Data de criação</Title>
                                    <Text>{
                                    order?.mercado_livre?.date_created ?
                                    convertDateTimeBr(order?.mercado_livre?.date_created.toString()):
                                    ""}</Text>
                                </Col>
                                <Col numColSpan={1}>
                                    <Title>Data de entrega prevista</Title>
                                    <Text>{
                                    order?.mercado_livre?.estimated_delivery_date ?
                                    convertDateTimeBr(order?.mercado_livre?.estimated_delivery_date?.toString()).substring(0, 10) :
                                    ""}</Text>
                                </Col>
                            </Grid>
                            <Divider/>
                            <Table> 
                                <TableHead>
                                    <TableRow>
                                        <TableHeaderCell>Status</TableHeaderCell>
                                        <TableHeaderCell>Sub Status</TableHeaderCell>
                                        <TableHeaderCell>Data</TableHeaderCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {Array.isArray(order?.meli_status_history) && order?.meli_status_history.length > 0 ? (
                                        order.meli_status_history
                                        .filter((event: any, index: number, array: any[]) => { // Mantém apenas se status ou substatus forem diferentes do anterior
                                            if (index === 0) return true;
                                            const prevEvent = array[index - 1];
                                            return (
                                              event.status !== prevEvent.status ||
                                              event.substatus !== prevEvent.substatus
                                            );
                                          })
                                        .map((event: any, index: number) => {
                                        const translatedStatus = meliStatusTranslate[event?.status] || event?.status;
                                        const translatedSubStatus = event?.substatus 
                                            ? meliSubStatusTranslate[event?.substatus] || event?.substatus 
                                            : "-";
                                        return (
                                            <TableRow key={event?.update_date || index}>
                                            <TableCell className="TableField">{translatedStatus}</TableCell>
                                            <TableCell className="TableField">{translatedSubStatus}</TableCell>
                                            <TableCell className="TableField">{convertDateTime(event?.update_date) || "Data inválida"}</TableCell>
                                            </TableRow>
                                        );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} className="text-center">Nenhum histórico encontrado</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>
                    </div>) : ('')}
                </div>

                {/* Shopee */}
                <div>
                { isShopeeOrder ?
                    <div className='px-8'>
                        <Card>
                            <Metric>Informações do pedido do Canal</Metric>
                            <Grid numCols={2} className="gap-2 mt-4">
                                <Col numColSpan={1}>
                                    <Title>Canal</Title>
                                    <Text className='max-w-md'>Shopee</Text>
                                </Col>

                                <Col numColSpan={1}>
                                    <Title>Status Logística</Title>
                                    <Text className='max-w-md'>{shopeeLogisticStatusTranslate[order?.shopee_data_status?.response?.logistics_status ?? '']}</Text>
                                </Col>

                                <Col numColSpan={1}>
                                    <Title>Tracking Number</Title>
                                    <Text className='max-w-md'>{order?.shopee_trackingno}</Text>
                                </Col>
                            </Grid>
                            <Divider/>
                            <Table> 
                                <TableHead>
                                    <TableRow>
                                        <TableHeaderCell>Data</TableHeaderCell>
                                        <TableHeaderCell>Status</TableHeaderCell>
                                        <TableHeaderCell>Descrição</TableHeaderCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {Array.isArray(order?.shopee_data_status?.response?.tracking_info) && (order?.shopee_data_status?.response?.tracking_info.length ?? 0) > 0 ? (
                                        order?.shopee_data_status?.response.tracking_info
                                        .sort((a: ShopeeTrackingInfo, b: ShopeeTrackingInfo) => a.update_time - b.update_time )
                                        .map((event: ShopeeTrackingInfo, index: number) => {
                                        const translatedStatus = statusChannelTranslate[event.logistics_status] || event?.logistics_status;
                                        return (
                                            <TableRow key={event?.update_time || index}>
                                            <TableCell className="TableField">{convertDateTimeTimestamp(event.update_time) || "Data inválida"}</TableCell>
                                            <TableCell className="TableField">{translatedStatus}</TableCell>
                                            <TableCell className="TableField">{event.description}</TableCell>
                                            </TableRow>
                                        );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} className="text-center">Nenhum histórico encontrado</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>
                    </div> 
                    : <></>}
                </div>
            </div>
            <br/>
            <div>
                {(!!order?.collecterImage) ?
                <Card>
                    <Metric>Imagem da entrega</Metric>
                    <img src={order?.collecterImage} className='max-h-[600px] max-w-[600px]'/>
                </Card>
                 :
                ""
                }
            </div>
        </div>
    </main>
  );
}